// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customText[data-v-4db372fe] {\n  color: rgba(0, 0, 0, 0.85);\n  text-align: left;\n  font-weight: 400;\n  font-size: 14px;\n}\n.rowHeight[data-v-4db372fe] {\n  height: 76px;\n}", ""]);
// Exports
module.exports = exports;
